var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpDefSU(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "spDef_s_u",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.004,
    height: 56.004,
    viewBox: "0 0 56.004 56.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON_Speaker_Stop"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_180",
    "data-name": "\\u6955\\u5186\\u5F62 180",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(11.997 12.002)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1497",
    "data-name": "\\u30D1\\u30B9 1497",
    d: "M0,0H56V56H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ICON_Volume-3",
    transform: "translate(15.997 16.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1275",
    "data-name": "\\u30D1\\u30B9 1275",
    d: "M5.484,5.2H0V12.92H5.484l5.154,5.143V.06Z",
    transform: "translate(5 2.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_2694",
    "data-name": "\\u9577\\u65B9\\u5F62 2694",
    width: 24,
    height: 24,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_2695",
    "data-name": "\\u9577\\u65B9\\u5F62 2695",
    width: 20,
    height: 20,
    transform: "translate(2 2)",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpDefSU);
export default __webpack_public_path__ + "static/media/spDef_s_u.42e28aea3b9050fca669545cbbe33489.svg";
export { ForwardRef as ReactComponent };